//@flow
import React from 'react'
import { connect } from 'react-redux'
import { Loader } from 'sputnik-ui'
import { withRouter } from 'react-router-dom'
import { Card, withSearch } from 'components'

import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import DomainIcon from '@material-ui/icons/Domain'

import { getHouses } from 'store/operations'
import { selectHouse } from 'store/actions'

const searchHouses = (props, query) => {
  const { selected, dispatch } = props

  const parent_uuid = selected.street.uuid
  const q = query || null

  dispatch(
    getHouses({
      parent_uuid,
      q,
    }),
  )
}

const Houses = ({ houses, err, dispatch, history, ...props }) => {
  if (!houses) {
    return <Loader msg="Загружаем список домов..." err={err} />
  }

  return (
    <Card title="Дома" titleIcon={<DomainIcon />} {...props}>
      {houses.map(h => (
        <ListItem
          key={h.uuid}
          button
          onClick={() => {
            dispatch(selectHouse(h))
            history.push(`/h/${h.uuid}`)
          }}
          disableRipple
        >
          <ListItemIcon>
            <DomainIcon />
          </ListItemIcon>
          <ListItemText primary={h.full_name} />
          <ListItemSecondaryAction style={{ paddingRight: '1rem' }}>
            <ArrowForwardIcon />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </Card>
  )
}

const mapStateToProps = ({ resources }) => ({
  houses: resources.current && resources.current.houses,
  err: resources.err,
})

let toExp = withSearch(searchHouses)(Houses)
toExp = withRouter(toExp)

export default connect(mapStateToProps)(toExp)
